"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unSubscribe = exports.subscribe = exports.stages = exports.removeAPiError = exports.loadPrefill = exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _okoApi = _interopRequireWildcard(require("../api/okoApi"));
var _doubleOptInApi = _interopRequireWildcard(require("../api/doubleOptInApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var COMMUNICATION_SUBSC_SAVE_SUCCESS = 'api/reducer/COMMUNICATION_SUBSC_SAVE_SUCCESS';
var COMMUNICATION_SUBSC_SAVE_FAIL = 'api/reducer/COMMUNICATION_SUBSC_SAVE_FAIL';
var COMMUNICATION_SUBSC_REMOVE_ERROR = 'api/reducer/COMMUNICATION_SUBSC_REMOVE_ERROR';
var COMMUNICATION_PREFILL = 'api/reducer/COMMUNICATION_PREFILL';
var stages = exports.stages = {
  FirstStep: 'FirstStep',
  SuccesStep: 'SuccesStep'
};

// Reducer
var communicationReducer = function communicationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case COMMUNICATION_SUBSC_SAVE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        step: stages.SuccesStep
      });
    case COMMUNICATION_SUBSC_SAVE_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        apiErrors: action.data.errorCode
      });
    case COMMUNICATION_SUBSC_REMOVE_ERROR:
      {
        var noErr = {};
        noErr[action.data.errorName] = false;
        return _objectSpread(_objectSpread({}, state), {}, {
          apiErrors: _objectSpread(_objectSpread({}, state.apiErrors), noErr)
        });
      }
    case COMMUNICATION_PREFILL:
      return _objectSpread(_objectSpread({}, state), {}, {
        prefillData: _objectSpread(_objectSpread({}, action.data), {}, {
          invitationId: action.param
        })
      });
    default:
      return state;
  }
};

// Action Creators
var subscribe = exports.subscribe = function subscribe(dispatch, payload) {
  var isOko = payload.isOko,
    rest = (0, _objectWithoutProperties2.default)(payload, ["isOko"]);
  var request = isOko ? (0, _okoApi.default)(rest) : (0, _doubleOptInApi.default)(rest);
  request.then(function (response) {
    var loadedData = response && response.data;
    dispatch({
      type: COMMUNICATION_SUBSC_SAVE_SUCCESS,
      data: {
        innerData: loadedData
      }
    });
  }).catch(function (response) {
    var errorCode = response && response.response.data.errors && response.response.data.errors[0] && response.response.data.errors[0].code.split('.').pop();
    var errs = {};
    if (errorCode === 'invalidInput') {
      errs.policyCheckFailed = true;
      errs.policyCheckFailedVk = true;
      errs.policyCheckFailedGp = true;
    } else {
      errs[errorCode] = true;
    }
    dispatch({
      type: COMMUNICATION_SUBSC_SAVE_FAIL,
      data: {
        errorCode: errs
      }
    });
  });
  return request;
};
var unSubscribe = exports.unSubscribe = function unSubscribe(dispatch, payload) {
  var isOko = payload.isOko,
    rest = (0, _objectWithoutProperties2.default)(payload, ["isOko"]);
  var request = isOko ? (0, _okoApi.anOkoUnsub)(rest) : (0, _doubleOptInApi.doubleOptInUnsub)(rest);
  request.then(function (response) {
    var loadedData = response && response.data;
    dispatch({
      type: COMMUNICATION_SUBSC_SAVE_SUCCESS,
      data: {
        innerData: loadedData
      }
    });
  }).catch(function (response) {
    var errorCode = response && response.response.data.errors && response.response.data.errors[0] && response.response.data.errors[0].code.split('.').pop();
    var errs = {};
    if (errorCode === 'invalidInput') {
      errs.policyCheckFailed = true;
      errs.policyCheckFailedGp = true;
    } else if (errorCode) {
      errs[errorCode] = true;
    } else {
      errs.unknownError = true;
    }
    dispatch({
      type: COMMUNICATION_SUBSC_SAVE_FAIL,
      data: {
        errorCode: errs
      }
    });
  });
  return request;
};
var removeAPiError = exports.removeAPiError = function removeAPiError(dispatch, errorName) {
  dispatch({
    type: COMMUNICATION_SUBSC_REMOVE_ERROR,
    data: {
      errorName: errorName
    }
  });
};
var loadPrefill = exports.loadPrefill = function loadPrefill(dispatch, payload) {
  var request = (0, _okoApi.prefillOko)(payload);
  request.then(function (response) {
    var loadedData = response && response.data;
    dispatch({
      type: COMMUNICATION_PREFILL,
      data: loadedData,
      param: payload.subscriptionInvitationId
    });
  }).catch(function () {
    dispatch({
      type: COMMUNICATION_PREFILL,
      data: null
    });
  });
  return request;
};
var _default = exports.default = communicationReducer;